export function formatCurrency(amount) {
 
    const formatter = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      
    });
  
   var result =  formatter.format((amount)).replace('₺', '')
   
   if (result != 'NaN') {
    return result;
   }
    return amount;
  }